import React from 'react';
import {Switch, Route, Redirect, withRouter} from 'react-router-dom';
import HomeContainer from './HomeContainer';
import LoginContainer from './LoginContainer';
import {connect} from 'react-redux';

const AppRouter = ({main, room, translate}) => {
    return (
        <div id="root" style={{overflowX: 'hidden'}}>
            <Switch>
                <Route exact path="/" component={() => { return <Redirect to={"/login"} /> }} />
                <Route path="/login" component={LoginContainer} />
                <Route path="/home" component={HomeContainer}/>
            </Switch>
        </div>
    );
};


const mapStateToProps = (state) => ({
    main: state.main
});

export default withRouter(connect(mapStateToProps)(AppRouter));


// WEBPACK FOOTER //
// ./src/containers/AppRouter.js